import { useEffect } from 'react'
import { Capacitor } from '@capacitor/core'
import { employeeApi } from './employeeApi'

// Appelé après chaque login pour enregistrer le token FCM
export async function registerFcmToken(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return
  try {
    const { PushNotifications } = await import('@capacitor/push-notifications')
    const { receive } = await PushNotifications.requestPermissions()
    if (receive !== 'granted') return
    await PushNotifications.register()
  } catch (e) {
    console.error('[fcm] registerFcmToken error:', e)
  }
}

export function useFcm() {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    let cleanup: (() => void) | undefined

    async function init() {
      try {
        const { PushNotifications } = await import('@capacitor/push-notifications')

        // Réception du token FCM → envoi au backend
        const regListener = await PushNotifications.addListener('registration', async ({ value }) => {
          try {
            await employeeApi.post('/employee/me/fcm-token', { token: value })
          } catch {}
        })

        // Affichage des notifs reçues en foreground
        const notifListener = await PushNotifications.addListener('pushNotificationReceived', notification => {
          console.log('[fcm] received:', notification.title)
        })

        // Clic sur une notification → navigation
        const actionListener = await PushNotifications.addListener('pushNotificationActionPerformed', action => {
          const url = action.notification?.data?.url
          if (url) window.location.hash = url
        })

        // Demander permission et déclencher register() APRÈS que le listener est en place
        const { receive } = await PushNotifications.requestPermissions()
        if (receive === 'granted') {
          await PushNotifications.register()
        }

        cleanup = () => {
          regListener.remove()
          notifListener.remove()
          actionListener.remove()
        }
      } catch (e) {
        console.error('[fcm] init error:', e)
      }
    }

    init()
    return () => { if (cleanup) cleanup() }
  }, [])
}
